import { Breadcrumbs, Button, Typography } from "@mui/material";
import { Download } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { Admin_Parivartan_Buisness_List } from "../../../constants";
import axios from "axios";
import BuisnessTableComponent from "./components/BuisnessTableComponent";
import AddNewBuisnessModal from "./components/AddNewBuisnessModal";

const BuisnessComponent = () => {
  const [addNewBuisnessModalOpen, setAddNewBuisnessModalOpen] = useState(false);
  const [buisnessList, setBuisnessList] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleBack = () => {};

  const fetchBuisnessData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${Admin_Parivartan_Buisness_List}`);
      const buisness = response.data.data || [];
      setBuisnessList(buisness);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching buisness data:", error);
      return null;
    }
  };

  useEffect(() => {
    fetchBuisnessData();
  }, []);

  const columns = [
    { headerName: "Buisness Name", field: "name" },
    
  ];

  const fetchBuisnessDataExport = async () => {
    try {
      const response = await axios.get(`${Admin_Parivartan_Buisness_List}`);
      const buisness = response.data.data || [];

      return buisness;
    } catch (error) {
      console.error("Error fetching buisness data:", error);
      return null; 
    }
  };

  const handleExport = async () => {
    const data = await fetchBuisnessDataExport();
    if (!data || data.length === 0) {
      console.warn("No data to export");
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = [
      columns.map((column) => column.headerName), // Header row
      ...data.map((row) =>
        columns.map((column) => {
          const value = row[column.field];
         
          return value || "";
        })
      ),
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Buisness_Data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `buisness_data_${dayjs().format("YYYYMMDD")}.xlsx`);
  };

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key="1"
          color="inherit"
          to="/settings"
          onClick={handleBack}
        >
          Admin Panel
        </Link>
        <Typography key="2" color="text.primary">
          Buisness Management
        </Typography>
      </Breadcrumbs>

      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">Buisness Management</h1>
          </div>
          <div>
            <Button
              onClick={() => setAddNewBuisnessModalOpen(true)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              sx={{ mr: 1 }}
            >
              Add New Buisness
            </Button>

            <Button
              onClick={() => handleExport()}
              variant="contained"
              color="secondary"
              startIcon={<Download />}
              sx={{ mr: 1 }}
            >
              Download
            </Button>
          </div>
        </div>

        <BuisnessTableComponent
          buisnessList={buisnessList}
          loading={loading}
          setLoading={setLoading}
          onRefresh={fetchBuisnessData}
        />

        <AddNewBuisnessModal
          open={addNewBuisnessModalOpen}
          onClose={() => setAddNewBuisnessModalOpen(false)}
          onRefresh={fetchBuisnessData}
        />
      </div>
    </>
  );
};

export default BuisnessComponent;
